import { Link as RouterLink } from 'react-router-dom';
import styled from 'styled-components';

export const OrganizationLink = styled(RouterLink)`
  padding: 6px;
  background: var(--color-surface-muted);
  color: var(--color-text-muted);
  font-weight: 500;
  font-size: 12px;
  line-height: 90%;
  border-radius: 5px;
  display: inline-flex;
  align-items: center;
  margin: 0 10px 10px 0;
  text-decoration: none;

  &:hover {
    color: var(--color-accent);
  }
`;
